export default __webpack_public_path__ + "static/media/ce0462f6becce890d39eaf6656392bf01581618463259.3c8ff8fd.webp";